export const PERSIAN_MONTHS = [
  "فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور",
  "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند",
];

export const toEnglishDigits = (value = "") =>
  String(value)
    .replace(/[۰-۹]/g, (digit) => "۰۱۲۳۴۵۶۷۸۹".indexOf(digit))
    .replace(/[٠-٩]/g, (digit) => "٠١٢٣٤٥٦٧٨٩".indexOf(digit));

export function getCurrentPersianYearMonth() {
  try {
    const parts = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
      year: "numeric",
      month: "numeric",
    }).formatToParts(new Date());

    const year = Number(
      toEnglishDigits(parts.find((p) => p.type === "year")?.value || ""),
    );
    const month = Number(
      toEnglishDigits(parts.find((p) => p.type === "month")?.value || ""),
    );

    if (year && month) return { year, month };
  } catch (e) {
    // Keep the UI usable in browsers without Persian calendar support.
  }

  const now = new Date();
  return { year: now.getFullYear(), month: now.getMonth() + 1 };
}

export function getCurrentPersianDate() {
  try {
    const parts = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    }).formatToParts(new Date());

    const year = Number(toEnglishDigits(parts.find((p) => p.type === "year")?.value || ""));
    const month = Number(toEnglishDigits(parts.find((p) => p.type === "month")?.value || ""));
    const day = Number(toEnglishDigits(parts.find((p) => p.type === "day")?.value || ""));

    if (year && month && day) return { year, month, day };
  } catch (e) {
    // fallback
  }

  const now = new Date();
  return { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
}

/** Convert an arbitrary Gregorian Date to Persian {year, month, day} */
export function getPersianDateFromGregorian(date = new Date()) {
  try {
    const parts = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    }).formatToParts(date);

    const year = Number(toEnglishDigits(parts.find((p) => p.type === "year")?.value || ""));
    const month = Number(toEnglishDigits(parts.find((p) => p.type === "month")?.value || ""));
    const day = Number(toEnglishDigits(parts.find((p) => p.type === "day")?.value || ""));

    if (year && month && day) return { year, month, day };
  } catch (e) {
    // fall through
  }

  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
  };
}

/** Jalali month length (Esfand leap years: 33-year cycle used by the backend). */
export function persianDaysInMonth(year, month) {
  const y = Number(year);
  const m = Number(month);
  if (m >= 1 && m <= 6) return 31;
  if (m >= 7 && m <= 11) return 30;
  if (m === 12) {
    return [1, 5, 9, 13, 17, 22, 26, 30].includes(y % 33) ? 30 : 29;
  }
  return 30;
}

export function getPersianMonthOptions() {
  return PERSIAN_MONTHS.map((label, i) => ({ value: i + 1, label }));
}
